// biGENİŞLETME — Kullanıcı davet-kabul sayfası (public) → /kurum-davet/:token
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const S = {
  wrap: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "linear-gradient(135deg,#1b1560,#3f2fb0 60%,#6d4ae0)", padding: 20, fontFamily: "-apple-system,Segoe UI,Roboto,sans-serif" },
  card: { background: "#fff", borderRadius: 20, padding: "38px 34px", width: "100%", maxWidth: 440, boxShadow: "0 20px 60px rgba(0,0,0,.25)" },
  h1: { margin: "0 0 6px", fontSize: 24, color: "#1b1560", fontWeight: 800 },
  sub: { margin: "0 0 22px", color: "#5a6178", fontSize: 15, lineHeight: 1.5 },
  label: { display: "block", fontSize: 13, fontWeight: 600, color: "#2a2270", margin: "12px 0 5px" },
  input: { width: "100%", padding: "12px 14px", borderRadius: 10, border: "1px solid #d7dbe8", fontSize: 15, boxSizing: "border-box" },
  btn: { width: "100%", marginTop: 22, padding: "14px", borderRadius: 11, border: 0, background: "#3f2fb0", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer" },
  chip: { display: "inline-block", background: "#f3f1ff", color: "#3f2fb0", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 700, marginBottom: 14 },
  err: { background: "#fdecef", color: "#b23a48", padding: "10px 14px", borderRadius: 10, fontSize: 14, marginTop: 14 },
  ok: { background: "#e6f2eb", color: "#2f7a52", padding: "12px 14px", borderRadius: 10, fontSize: 15, marginTop: 14, textAlign: "center" },
};

export default function KurumDavet() {
  const { token } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState("loading"); // loading|form|done|invalid
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState({ name: "", surname: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`/api/platform/org/invite/${token}`)
      .then((r) => r.ok ? r.json() : Promise.reject(r))
      .then((d) => {
        const iv = d.data;
        if (!iv || iv.status !== "beklemede") { setState("invalid"); return; }
        setInfo(iv);
        setForm((f) => ({ ...f, name: (iv.name || "").split(" ")[0] || "", surname: (iv.name || "").split(" ").slice(1).join(" ") }));
        setState("form");
      })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async () => {
    setErr("");
    if (!form.password || form.password.length < 6) return setErr("En az 6 karakterlik bir şifre belirleyin.");
    setBusy(true);
    try {
      const r = await fetch(`/api/platform/org/invite/${token}/accept`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form),
      });
      const d = await r.json();
      if (!r.ok) { setErr(d.message || "Davet kabul edilemedi."); setBusy(false); return; }
      setState("done");
      setTimeout(() => nav("/login"), 2500);
    } catch (e) { setErr("Bağlantı hatası, tekrar deneyin."); setBusy(false); }
  };

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        {state === "loading" && <p style={S.sub}>Davet kontrol ediliyor…</p>}

        {state === "invalid" && (
          <>
            <h1 style={S.h1}>Davet geçersiz</h1>
            <p style={S.sub}>Bu davet bağlantısı bulunamadı, süresi dolmuş veya daha önce kullanılmış olabilir. Lütfen kurumunuzla iletişime geçin.</p>
            <button style={S.btn} onClick={() => nav("/login")}>Giriş sayfasına git</button>
          </>
        )}

        {state === "form" && info && (
          <>
            <span style={S.chip}>{info.orgName} sizi davet etti</span>
            <h1 style={S.h1}>Eğitiminizi başlatın</h1>
            <p style={S.sub}>
              <b>{info.email}</b> için biYAPAYZEKA erişiminizi açmak üzeresiniz. Uzman Yapay Zeka Öğretmenleriyle özel ders formatında eğitim sizi bekliyor.
            </p>
            <label style={S.label}>Ad</label>
            <input style={S.input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <label style={S.label}>Soyad</label>
            <input style={S.input} value={form.surname} onChange={(e) => setForm({ ...form, surname: e.target.value })} />
            <label style={S.label}>Şifre belirleyin</label>
            <input style={S.input} type="password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="En az 6 karakter" />
            {err && <div style={S.err}>{err}</div>}
            <button style={{ ...S.btn, opacity: busy ? .6 : 1 }} disabled={busy} onClick={submit}>
              {busy ? "İşleniyor…" : "Erişimimi Aç"}
            </button>
          </>
        )}

        {state === "done" && (
          <>
            <h1 style={S.h1}>Hoş geldiniz! 🎉</h1>
            <div style={S.ok}>Erişiminiz açıldı. Giriş sayfasına yönlendiriliyorsunuz…</div>
          </>
        )}
      </div>
    </div>
  );
}
